/**
 * Result object returned by DeleteQueryBuilder execution.
 */
export class DeleteResult {

    raw: any;

}